import React, { useCallback, useRef, useState } from 'react';
import { ScrollableViewport } from '../ScrollableViewport';
import { useOnClickOutside } from '../../hooks';
import { Icon } from '../Icon';
import { dropdownCss } from './utils';
import './Dropdown.scss';
import { ComponentWrapper } from '../ComponentWrapper';
export const Dropdown = ({ options = [], value, onChange, className, iconSrc, labelText = '', placeholder = 'Select...', truncateLongValues = false, disabled = false, overrideCss = false, customHeaderComponent: CustomHeaderComponent = React.createElement(React.Fragment, null), }) => {
    const { dropdown, dropdownArrow, dropdownLabel, dropdownIcon, dropdownOptionBox, dropdownOptionItem, dropdownOptionItemSelected, dropdownSelectedValue, dropdownSelectionBox, } = dropdownCss({
        isTruncate: truncateLongValues,
        customClassName: className,
        overrideCss,
        disabled,
    });
    const [isOpen, setOpen] = useState(false);
    const ref = useRef(null);
    const displayValue = value || placeholder;
    useOnClickOutside(ref, () => setOpen(false));
    const handleSelection = useCallback((option) => {
        onChange(option);
        setOpen(false);
    }, [onChange]);
    const handleOpen = () => {
        if (!disabled) {
            setOpen(!isOpen);
        }
    };
    return (React.createElement("div", { ref: ref, className: dropdown },
        React.createElement("button", { className: dropdownSelectionBox, onClick: handleOpen, type: "button" },
            iconSrc ? (React.createElement("div", { className: dropdownIcon },
                React.createElement(Icon, { source: iconSrc, altText: labelText }))) : null,
            React.createElement("div", null,
                labelText ? React.createElement("div", { className: dropdownLabel }, labelText) : null,
                React.createElement("div", { className: dropdownSelectedValue }, displayValue),
                !disabled ? React.createElement("div", { className: dropdownArrow }) : null)),
        isOpen ? (React.createElement("div", { className: dropdownOptionBox },
            React.createElement(ComponentWrapper, { component: CustomHeaderComponent }),
            React.createElement(ScrollableViewport, { vertical: true }, options.map((opt) => {
                const optionClass = opt.displayText === value
                    ? dropdownOptionItemSelected
                    : dropdownOptionItem;
                return (React.createElement("button", { className: optionClass, key: opt.value, onClick: () => handleSelection(opt.value), type: "button" }, opt.displayText));
            })))) : null));
};
//# sourceMappingURL=Dropdown.js.map